import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Paginations from '../../../services/paginations'
import EntryList from '../../../services/entries'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'
import AlertConfirmation from '../../../services/confirmation'
import { DropdownComponent } from '../../../components/options'

import AuthDenied from '../../ErrorPage/denied'

export default function ComplianceProductListComponent(props){

  const FormReference = useRef();

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='confirm'){
      DeleteRecord(data.id);
    }
  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  function handleSubmitForm(values, props){
    if(buttonclick==1){
      props.resetForm();
      TableList(pagenumber,search);
    }else{
      let value={
        name:values.name,
        message:values.message,
      }
      TableList(pagenumber,values);
    }
  }
  function ReloadList(){
    let value={
      name:'',
      message:'',
    }
    TableList(pagenumber,value);
  }

  const [search, setsearch]  = useState({
      name:'',
      message:'',
	});
  const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	  function pagenumberfunction(page){
				setpagenumber(page);
        let values={
          name:FormReference.current.values.name,
          message:FormReference.current.values.message,
        }
				TableList(page,values);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/compliance/products/request.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
            setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
          setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
          setnotify(true);
				});
	}


  /*------------------------------------------------------
          DELETE FUNCTION
  -------------------------------------------------------*/
  function DeleteConfirmation(id){
    setconfirmcontent({intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, record will be deleted forever on the server.'}});
    setconfirm(true);
  }


  function DeleteRecord(id){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);
    setconfirm(false);

    let formData = new FormData();
    formData.append('type','delete');
    formData.append('id',id);
    axios.post('/admin/compliance/products/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setspinner(false);

        if(obj=='data_used'){
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Delete Denied!',text:'The record cannot be deleted because it is associated with another record.'}});
          setnotify(true);
          return false;
        }


        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully deleted.'}});
          setnotify(true);
          TableList(pagenumber,search);
          setTimeout(function() {setnotify(false);},2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Delete Failed',text:'Record not successfully deleted.'}});
          setnotify(true);
          setTimeout(function() {setnotify(false);},2000);
        }

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
}





  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [statusOptions, setStatusDropdown] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusDropdown(source.status);
  }



  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('97vpbxth85asmrefy');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          TableList(pagenumber,search);
          HandleOptions();
        }
        setloader(false);

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
    });
 }

  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>



       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>


       <div className="app-page-title"><h1>Product Compliance</h1></div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
       <Formik
         initialValues={search}
         onSubmit={handleSubmitForm}
         innerRef={FormReference}
          >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {
         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>
                  <Form.Group widths="equal">
                      <Field name="name">
                          {({ field, form }) => (
                          <Form.Field>
                            <label>Name</label>
                            <Input fluid {...field} onChange={handleChange}/>
                          </Form.Field>
                          )}
                        </Field>
                        <Field name="message">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Message</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                          </Field>
                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer">
                <Button type="button" icon='sync alternate' size='tiny' className="LightGrayButton" content='Reset' onClick={() => buttonSubmit(1)}/>
                <Button type="button" icon='search' size='tiny' className="LightGrayButton" content='Search' onClick={() => buttonSubmit(2)}/>
                <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
              </div>
           </div>
          </React.Fragment>  
          )}}
        </Formik>





      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>
      <div className="tableWrapper">
       <div className="panel-table">

         <div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div>
            <Button disabled={authPages['adding']==0} className='GreenButton' size='tiny' content='Create Compliance'  icon='plus' as='a' href={WindowURL('/compliance/product/new')} />
           </div>
         </div>

         <div className="panel-table-body">
         <div className="table-responsive">
           <Table celled compact='very'>
             <Table.Header>
               <Table.Row>
                 <Table.HeaderCell>Name</Table.HeaderCell>
                 <Table.HeaderCell>Message</Table.HeaderCell>
                 <Table.HeaderCell></Table.HeaderCell>
               </Table.Row>
             </Table.Header>

             <Table.Body>
                   {list.length==0&&<Table.Row negative><Table.Cell  colSpan='3' textAlign="center">No record found</Table.Cell></Table.Row>}
                   {list.map(function(data, key){
                     return <Table.Row key={key} verticalAlign='top'>
                         <Table.Cell>{data.name}</Table.Cell>
                         <Table.Cell>{data.message}</Table.Cell>
                         <Table.Cell collapsing>

                         <Button disabled={authPages['editing']==0} className='BlueButton' size='tiny' content='Edit'  icon='uil-edit icon' as='a' href={WindowURL('/compliance/product/edit/'+data.id)}/>
                         <Button disabled={authPages['deleting']==0} className='RedButton' size='tiny' content='Delete' icon='uil-trash-alt icon' onClick={()=>DeleteConfirmation(data.id)} />

                         </Table.Cell>
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='3'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>

        </React.Fragment>}

       </div>{/*.app-body-wrapper*/}
       </React.Fragment>}
    </React.Fragment>
  )
}
